import useValidator from '../../../../utils/hooks/useValidator'
import { invalidNumberInput, premiumLinkRegex } from '../../../../utils'
import {
  BiddingStrategyTypes,
  CampaignTypes,
  MaxBiddingAmountChangeTypes,
} from '../../../Codes'
import { useSelector } from 'react-redux'

const useKeywordValidator = () => {
  const {
    campaign: {
      form: { campaignType },
    },
    keyword: {
      form: {
        texts,
        suggestions,
        maxBiddingAmount,
        biddingStrategyType,
        maxBiddingAmountChangeType,
        useRankAmount,
        rankAmount,
      },
    },
  } = useSelector(state => state.ad)
  const { errors, validate } = useValidator(
    () => ({
      texts:
        (texts.length === 0 &&
          suggestions.length === 0 &&
          '등록 키워드를 1개 이상 입력하셔야 합니다.') ||
        (texts.length + suggestions.length > 300 &&
          '입력가능한 키워드 개수를 초과하였습니다.\n기존에 등록된 키워드를 삭제하세요.') ||
        (campaignType === CampaignTypes.PREMIUM_LINK &&
          texts.some(item => !premiumLinkRegex.test(item)) &&
          '입력 불가능한 문자가 입력되어 있습니다.\n(특수문자 일부, 한자 입력 불가능)'),
      maxBiddingAmount:
        maxBiddingAmountChangeType ===
          MaxBiddingAmountChangeTypes.NO_CALCULATE &&
        biddingStrategyType ===
          BiddingStrategyTypes.FIXBIDDING_BY_CUSTOM_MAX_BIDDING &&
        ((maxBiddingAmount === '' && '입찰단가를 입력해주세요.') ||
          (invalidNumberInput(maxBiddingAmount, 100000, 70, 10) &&
            '입찰단가는 최소 70원 ~ 최대 100,000원까지 10원 단위로 설정해주세요.')),
      rankAmount:
        maxBiddingAmountChangeType === MaxBiddingAmountChangeTypes.RANK &&
        useRankAmount &&
        invalidNumberInput(rankAmount, 100000, 70, 10) &&
        '최대 입찰가는 최소 70원, 최대 100,000원 범위 내에서 10원 단위로 등록 가능합니다.',
    }),
    [
      campaignType,
      texts,
      suggestions,
      maxBiddingAmount,
      biddingStrategyType,
      maxBiddingAmountChangeType,
      useRankAmount,
      rankAmount,
    ]
  )
  return {
    errors,
    validate,
  }
}
export default useKeywordValidator
